export function whitelist<T>(value: T, ...args: T[]) {
  return args.includes(value);
}

export function blacklist<T>(value: T, ...args: T[]) {
  return !args.includes(value);
}
